<div class="rpc-notification-appointment"
    [class.rpc-notification-appointment--comment]="appointmentNotification.comment"
    [class.rpc-notification-appointment--footer]="statusDetails.isPendingCreatedByAgent || 
    (notificationAction !== NotificationEventAction.AppointmentCreated && !statusDetails.isPending)">

    <div class="rpc-notification-appointment-address" [title]="listingAddress" (click)="onAppointmentClick(false)">
        {{ listingAddress }}
    </div>

    <div class="rpc-notification-appointment-date">

        <div>
            {{ appointmentNotification.startDateTime | timePeriodLabel : appointmentNotification.endDateTime }}
        </div>

        <div class="rpc-divider rpc-divider--vertical rpc-notification-appointment-date-divider">
        </div>

        <div>
            {{ appointmentNotification.startDateTime | date: DateConstants.Formats.AngularPipeShortDateSlash}}
        </div>

    </div>

    @if (appointmentNotification.comment) {
    <div class="rpc-notification-appointment-comment">
        {{appointmentNotification.comment}}
    </div>
    }

    @if (statusDetails.isPendingCreatedByAgent ||
    (notificationAction !== NotificationEventAction.AppointmentCreated && !statusDetails.isPending)) {
    <div class="rpc-notification-appointment-footer">

        @if (statusDetails.isPendingCreatedByAgent) {

        @if (actionOptions.canAccept) {
        <rpc-button class="rpc-notification-appointment-btn rpc-notification-appointment-btn--accept"
            [text]="'APPOINTMENT_NOTIFICATION.TITLES.ACCEPT'" [iconName]="'accept'" (clicked)="onAccept($event)">
        </rpc-button>
        }

        @if (actionOptions.canDecline) {
        <rpc-button class="rpc-notification-appointment-btn rpc-notification-appointment-btn--decline"
            [text]="'APPOINTMENT_NOTIFICATION.TITLES.DECLINE'" [iconName]="'decline'" (clicked)="onDecline($event)">
        </rpc-button>
        }

        } @else {

        @if (notificationAction !== NotificationEventAction.AppointmentCreated && (statusDetails.isConfirmed ||
        statusDetails.isDeclined || statusDetails.isShown)) {
        @let statusAttributes = appointmentStatusAttributes.get(status);

        <div class="rpc-notification-appointment-status" [class]="statusAttributes.class">

            <rpc-icon class="rpc-notification-appointment-status-icon" [iconName]="statusAttributes.icon">
            </rpc-icon>

            <div class="rpc-notification-appointment-status-text">
                {{statusAttributes.title | translate}}
            </div>

        </div>
        }

        }

    </div>
    }

    <rpc-button class="rpc-notification-appointment-link" [text]="'APPOINTMENT_NOTIFICATION.TITLES.ALL_APPOINTMENTS'"
        [color]="'accent'" (clicked)="onAppointmentClick(true)">
    </rpc-button>

</div>